// extracted by mini-css-extract-plugin
export default {"title":"verify-user-modal_title__CG6o8","subtitle":"verify-user-modal_subtitle__ud2UA","content":"verify-user-modal_content__ssFzI"};